import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ModalMovimientos from './ModalMovimientos';
import OperacionesPagosModal from './OperacionesPagosModal/index';
import TomorrowTurnosModal from './TomorrowTurnosModal';
import { FaUserCircle, FaBars } from 'react-icons/fa';

function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sucursalNombre, setSucursalNombre] = useState('');
  const [admin, setAdmin] = useState(false);
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [isMovimientosModalOpen, setIsMovimientosModalOpen] = useState(false);
  const [isOperacionesPagosModalOpen, setIsOperacionesPagosModalOpen] = useState(false);
  const [isTomorrowTurnosModalOpen, setIsTomorrowTurnosModalOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const nombre = localStorage.getItem('sucursalNombre');
    const username = localStorage.getItem('nombreUsuario');
    const isAdmin = localStorage.getItem('admin');

    if (username) {
      const formattedUsername = username.charAt(0).toUpperCase() + username.slice(1).toLowerCase();
      setNombreUsuario(formattedUsername);
    }
    if (nombre) {
      setSucursalNombre(nombre);
    }
    if (isAdmin !== null) {
      setAdmin(isAdmin === 'true');
    }
  }, []);

  const handleDropdown = (dropdown) => {
    setOpenDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
    window.location.reload();
  };

  const handleOptionClick = () => {
    setOpenDropdown(null);
    setIsMobileDropdownOpen(false);
  };

  const toggleMobileDropdown = () => {
    setIsMobileDropdownOpen((prev) => !prev);
    setOpenDropdown(null);
  };

  return (
    <div className="z-50 mb-5">
      <nav className="bg-gray-800 bg-opacity-95 text-white w-full shadow-md fixed top-0 left-0 right-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Left - Logo */}
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-extrabold text-white tracking-wide hover:text-indigo-400 transition duration-300">
                {sucursalNombre}
              </Link>
            </div>

            {/* Right - Desktop Menu */}
            <div className="hidden md:flex space-x-6 items-center">
              <div className="relative group">
                <button
                  className="hover:text-indigo-300 transition duration-200 font-medium"
                  onMouseEnter={() => handleDropdown('inicio')}
                  onClick={() => handleDropdown('inicio')}
                >
                  Inicio
                </button>
                {openDropdown === 'inicio' && (
                  <div className="absolute mt-2 w-56 bg-white text-black border border-gray-200 rounded-lg shadow-lg animate-fadeIn">
                    <Link className="block px-4 py-2 hover:bg-gray-100" to="/Servicios" onClick={handleOptionClick}>Lista de servicios</Link>
                    <Link className="block px-4 py-2 hover:bg-gray-100" to="/clientes" onClick={handleOptionClick}>Clientes</Link>
                    <Link className="block px-4 py-2 hover:bg-gray-100" to="/" onClick={handleOptionClick}>Turnos</Link>
                    <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={handleLogout}>Salir</button>
                  </div>
                )}
              </div>

              {admin && (
                <div className="relative group">
                  <button
                    className="hover:text-indigo-300 transition duration-200 font-medium"
                    onMouseEnter={() => handleDropdown('admin')}
                    onClick={() => handleDropdown('admin')}
                  >
                    Administración
                  </button>
                  {openDropdown === 'admin' && (
                    <div className="absolute mt-2 w-64 bg-white text-black border border-gray-200 rounded-lg shadow-lg animate-fadeIn">
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/empleados" onClick={handleOptionClick}>Empleados</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/Horarios" onClick={handleOptionClick}>Horarios</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/gestion/metodos/pago" onClick={handleOptionClick}>Métodos de Pago</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/Comisiones" onClick={handleOptionClick}>Comisiones</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/liquidacion" onClick={handleOptionClick}>Liquidaciones</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/trabajos/Caja" onClick={handleOptionClick}>Caja Fuerte</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/caja/fuerte" onClick={handleOptionClick}>Operaciones de Caja</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/estadisticas" onClick={handleOptionClick}>Estadísticas</Link>
                      <Link className="block px-4 py-2 hover:bg-gray-100" to="/admin/gifts/cards" onClick={handleOptionClick}>Gift Cards</Link>
                    </div>
                  )}
                </div>
              )}

              {/* Standard Links */}
              <button className="hover:text-indigo-300 transition duration-200 font-medium" onClick={() => setIsMovimientosModalOpen(true)}>Operaciones</button>
              <button className="hover:text-indigo-300 transition duration-200 font-medium" onClick={() => setIsOperacionesPagosModalOpen(true)}>Caja</button>
              <Link className="hover:text-indigo-300 transition duration-200 font-medium" to="/gifts/cards">Gift Cards</Link>
              <button className="hover:text-indigo-300 transition duration-200 font-medium" onClick={() => setIsTomorrowTurnosModalOpen(true)}>Turnos de Mañana</button>
              <Link className="hover:text-indigo-300 transition duration-200 font-medium" to="/turnos/cancelados">Turnos Cancelados</Link>
            </div>

            {/* User Section */}
            <div className="hidden md:flex items-center space-x-2">
              <FaUserCircle className="text-white text-2xl" />
              <span className="font-semibold">{nombreUsuario}</span>
            </div>

            {/* Mobile Menu Icon */}
            <div className="md:hidden flex items-center">
              <button onClick={toggleMobileDropdown}>
                <FaBars className="text-white text-xl" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileDropdownOpen && (
        <div className="md:hidden bg-white text-black border-t border-gray-200 shadow-lg mt-16 animate-slideDown">
          <div className="px-4 py-4 space-y-2">
            <h2 className="text-lg font-bold text-gray-700">Inicio</h2>
            <Link className="block px-4 py-2 hover:bg-gray-100" to="/Servicios" onClick={handleOptionClick}>Lista de servicios</Link>
            <Link className="block px-4 py-2 hover:bg-gray-100" to="/clientes" onClick={handleOptionClick}>Clientes</Link>
            <Link className="block px-4 py-2 hover:bg-gray-100" to="/" onClick={handleOptionClick}>Turnos</Link>
            <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={handleLogout}>Salir</button>
            {admin && (
              <>
                <h2 className="text-lg font-bold text-gray-700 mt-4">Administración</h2>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/empleados" onClick={handleOptionClick}>Empleados</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/Horarios" onClick={handleOptionClick}>Horarios</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/gestion/metodos/pago" onClick={handleOptionClick}>Métodos de Pago</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/Comisiones" onClick={handleOptionClick}>Comisiones</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/Gestion/liquidacion" onClick={handleOptionClick}>Liquidaciones</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/trabajos/Caja" onClick={handleOptionClick}>Caja Fuerte</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/caja/fuerte" onClick={handleOptionClick}>Operaciones de Caja</Link>
                <Link className="block px-4 py-2 hover:bg-gray-100" to="/estadisticas" onClick={handleOptionClick}>Estadísticas</Link>
              </>
            )}
            <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => setIsMovimientosModalOpen(true)}>Operaciones</button>
            <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => setIsOperacionesPagosModalOpen(true)}>Caja</button>
            <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => setIsTomorrowTurnosModalOpen(true)}>Turnos de Mañana</button>
          </div>
        </div>
      )}

      <TomorrowTurnosModal isOpen={isTomorrowTurnosModalOpen} onClose={() => setIsTomorrowTurnosModalOpen(false)} />
      <ModalMovimientos isOpen={isMovimientosModalOpen} onClose={() => setIsMovimientosModalOpen(false)} />
      <OperacionesPagosModal isOpen={isOperacionesPagosModalOpen} onRequestClose={() => setIsOperacionesPagosModalOpen(false)} />
    </div>
  );
}

export default Navbar;
